module.exports = __webpack_public_path__ + "img/stripe-logo.181a10e3.svg";